import { render, staticRenderFns } from "./ModalFormUnidadMedida.vue?vue&type=template&id=6da36360"
import script from "./ModalFormUnidadMedida.vue?vue&type=script&lang=js"
export * from "./ModalFormUnidadMedida.vue?vue&type=script&lang=js"
import style0 from "./ModalFormUnidadMedida.vue?vue&type=style&index=0&id=6da36360&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports